import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CasiProjectUser, IProjectFromWeb } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiProjectUserService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(projectId: number): void {
    this.fetch(projectId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(projectId: number): Observable<CasiProjectUser[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/projectuser/byprojectsql/${projectId}`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => new CasiProjectUser(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjectUserService extends CasiProjectUserService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('projectuser', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`projectuser/${id}`, 'getById');
  }

  getByProjectId(projectId: number): Promise<any> {
    this.loading = true;
    return this.apiService
      .getHttpCallAsPromise(`projectuser/byprojectsql/${projectId}`, 'getByProjectId')
      .then(data => {
        return data.map((d: any) => new CasiProjectUser(d));
      })
      .catch(err => Promise.reject(err))
      .finally(() => this.loading = false);
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('projectuser', p, 'add');
  }

  bulkUpdate(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('projectuser/bulkaddupdate', p, 'bulkUpdate');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`projectuser/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`projectuser/${id}`, 'destroy');
  }
}
